// extracted by mini-css-extract-plugin
module.exports = {"item":"list_item__kznSM","skeletons":"list_skeletons__oBcTs","button":"list_button__rlof5"};